import {createStoreAPI} from './CreateStoreAPIService'

export const getProductCatalogById = (catalogId, slug) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL || 'https://seller-staging.merchize.com'}/api/product-line`
        },
        storeId: slug,
    })

    return api.makeAuthRequest({
        url: `/catalog-products/${catalogId}`,
        method: 'GET',
    })
}

export const getWebsiteProductCatalogById = (catalogId) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: `/website/catalog-products/${catalogId}`,
        method: 'GET',
    })
}

export const saveTempMockupDesign = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: `/website/products/temp`,
        method: 'POST',
        data,
    })
}

export const saveTempImagesDesign = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: `/website/design-images/temp`,
        method: 'POST',
        data,
    })
}

export const getListSKUPrivate = (params) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: '/catalog-products/list-sku-private',
        method: 'GET',
        params,
    })
}

export const searchCatalogProductsPresetV2 = (payload = {}) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: `catalog-products/preset/v2/search`,
        method: 'POST',
        data: payload,
    })
}

export const getCatalogCategories = () => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    const defaultParams = {
        limit: 1000,
        page: 1,
    }
    return api.makeAuthRequest({
        url: '/catalog-categories/search',
        method: 'POST',
        data: defaultParams,
    })
}

export const getProductCatalogsV2 = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: '/catalog-products/v2/search',
        method: 'POST',
        data,
    })
}

export const getProductCatalogs = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return `${process.env.REACT_APP_BASE_URL}/api/product-line`
        },
    })
    return api.makeAuthRequest({
        url: '/catalog-products/search',
        method: 'POST',
        data,
    })
}
